// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AssociationOverlayToggleController from "./association_overlay_toggle_controller"
application.register("association-overlay-toggle", AssociationOverlayToggleController)

import ContextMenuPreviewController from "./context_menu_preview_controller"
application.register("context-menu-preview", ContextMenuPreviewController)

import ExampleChiplistController from "./example_chiplist_controller"
application.register("example-chiplist", ExampleChiplistController)

import LineSortingController from "./line_sorting_controller"
application.register("line-sorting", LineSortingController)

import LoadingButtonExampleController from "./loading_button_example_controller"
application.register("loading-button-example", LoadingButtonExampleController)

import MarketplaceShowController from "./marketplace_show_controller"
application.register("marketplace-show", MarketplaceShowController)
